import Vue from 'vue';
import MXDialog from './MXDialog/MXDialog.vue';
import DistrictPicker from './DistrictPicker/DistrictPicker.vue';
import GlobalTip from './GlobalTip/GlobalTip.vue';

Vue.component(MXDialog.name, MXDialog);
Vue.component(DistrictPicker.name, DistrictPicker);
Vue.component(GlobalTip.name, GlobalTip);



// WEBPACK FOOTER //
// ./src/components/index.js